var $7bc76068ce4c3b7e$exports = {};
$7bc76068ce4c3b7e$exports = {
    "Clear search": `Ryd s\xf8gning`
};


export {$7bc76068ce4c3b7e$exports as default};
//# sourceMappingURL=da-DK.mjs.map
